import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// The back office's words for its data tables (ADR-033): the users and organizations tables'
// new columns, their filters and what an empty filtered page says. `ops-copy.ts` puts them
// together with the rest into the one catalogue the screens read.

export type TableCatalog = typeof EN;

const EN = {
  columnCreditsLeft: "Credits left",
  columnCreditsSpent: "Credits spent",
  creditsUnlimited: "Unlimited",
  filterPlan: "Plan",
  filterStatus: "Status",
  filterJoined: "Joined",
  columnJoined: "Joined",
  filterSeen: "Seen",
  seenWithin: { one: "In the last day", other: "In the last {count} days" },
  clearFilters: "Clear filters",
  emptyFiltered: "Nothing matches these filters.",
  emptyFilteredHint: "Clear a filter or search for something else.",
  unknownDate: "Unknown",
  organizationsTableLabel: "Every organization",
  peopleTableLabel: "Everyone with an account",
  settingsListLabel: "Settings",
};

const ES: Translation<TableCatalog> = {
  columnCreditsLeft: "Créditos disponibles",
  columnCreditsSpent: "Créditos gastados",
  creditsUnlimited: "Ilimitados",
  filterPlan: "Plan",
  filterStatus: "Estado",
  filterJoined: "Alta",
  columnJoined: "Alta",
  filterSeen: "Actividad",
  seenWithin: { one: "En el último día", other: "En los últimos {count} días" },
  clearFilters: "Quitar filtros",
  emptyFiltered: "Nada coincide con estos filtros.",
  emptyFilteredHint: "Quita un filtro o busca otra cosa.",
  unknownDate: "Sin dato",
  organizationsTableLabel: "Todas las organizaciones",
  peopleTableLabel: "Todas las personas con cuenta",
  settingsListLabel: "Ajustes",
};

export const TABLE_CATALOGS: Catalogs<TableCatalog> = { en: EN, es: ES };
